export class PushCartError extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['close']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.onItemClick.bind(this))
  }

  /**
   * @param {MouseEvent} e
   *
   * @returns {void}
   */
  onItemClick (e) {
    this.setAttribute('aria-hidden', 'true')

    window.setTimeout(() => {
      this.remove()
    }, 500)
  }
}

if (!customElements.get('push-cart-error')) {
  customElements.define('push-cart-error', PushCartError)
}
